module.exports = __webpack_public_path__ + "img/option-life-filled.c354f2e.png";